import { useEntryDaysQuery } from "@journal/shared/solid";
import { useJournalData } from "@/features/journal/hooks/use-journal-data";
import { useDailyReminder } from "@/features/journal/hooks/use-daily-reminder";

/**
 * Headless singleton that keeps the daily writing reminder in sync
 * with the local preference. It renders nothing — mount exactly
 * once inside the PowerSync provider (see `AppProviders`).
 */
export function ReminderScheduler() {
  const { db, drizzle, userId, staleTime } = useJournalData();
  const days = useEntryDaysQuery({ db, drizzle, userId, staleTime });

  useDailyReminder({
    lastEntryDay: () => days.data?.[0]?.entry_date ?? undefined,
  });

  return null;
}
